import React from 'react';
import classnames from 'classnames';

import styles from './LoadingPlaceholders.scss';

const {
  waffleContainer,
  inner,
  middle,
  outer,
} = styles;

function TodayLoadingLogo() {
  return (
    <div className={classnames('df justify-center pv8', waffleContainer)}>
      <svg
        width="89"
        height="45"
        viewBox="0 0 89 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="89"
          height="45"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 22.5V0.380127H89V44.6199H0V22.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0)">
          <path
            className={outer}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.9616 42.7862C88.0086 18.9167 68.4682 -0.140381 44.5016 -0.140381C20.7013 -0.140381 1.26005 18.6593 0.060764 42.3005C0.0191886 43.0725 0 43.8446 0 44.6199H11.5388C11.5388 43.8703 11.5643 43.1176 11.6155 42.3777C12.7668 25.135 27.0751 11.4663 44.5016 11.4663C61.992 11.4663 76.3451 25.2411 77.4005 42.5739C77.4421 43.2527 77.4644 43.9314 77.4644 44.6199H89C89 44.0086 88.9904 43.391 88.9616 42.7862Z"
            fill="#FFC0A2"
            fillOpacity="1"
          />
          <path
            className={middle}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M44.2398 14.9532C28.5109 14.9532 15.6445 27.1928 14.6371 42.6658C14.5891 43.3086 14.5731 43.9611 14.5731 44.6199H26.1091C26.1091 43.9131 26.1506 43.2095 26.2306 42.5219C27.2732 33.5157 34.9553 26.4892 44.2398 26.4892C53.5754 26.4892 61.2863 33.5829 62.2649 42.6594C62.3353 43.3054 62.3705 43.9547 62.3705 44.6199H73.9064C73.9064 43.9835 73.8872 43.363 73.8489 42.7362C72.8766 27.228 59.991 14.9532 44.2398 14.9532Z"
            fill="#FFC0A2"
            fillOpacity="1"
          />
          <path
            className={inner}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M44.5 30.0468C37.2656 30.0468 31.2402 35.1296 29.9321 41.8585C29.7594 42.7507 29.6667 43.6743 29.6667 44.6199H59.3333C59.3333 43.9099 59.2822 43.2188 59.183 42.5465C58.1596 35.4783 51.9774 30.0468 44.5 30.0468Z"
            fill="#FFC0A2"
            fillOpacity="1"
          />
        </g>
      </svg>
    </div>
  );
}

export default TodayLoadingLogo;
